module.exports = __webpack_public_path__ + "img/UnderReview.b74d7843.png";